import { setRecentlyUsedAirportCode } from 'actions/AuthActions'
import { fetchOfferFlightPrice } from 'actions/OfferActions'
import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { useAppDispatch } from 'hooks/reduxHooks'
import useMountedEffect from 'hooks/useMountedEffect'

interface Options {
  airport: OfferPageState['airport']
  airportSource: OfferPageState['airportSource']
  offerId: string
  charterBundleRoute?: App.CharterBundleRoute
}

function useOfferPageAirportEffects({ airport, airportSource, offerId, charterBundleRoute }: Options) {
  const dispatch = useAppDispatch()

  useMountedEffect(() => {
    if (airport && airportSource === 'user') {
      dispatch(setRecentlyUsedAirportCode(airport.code))
    }
  }, [airport, airportSource, dispatch])

  useMountedEffect(() => {
    // Charter offers use charter pricing, but explicit origins are still saved above.
    if (airport && !charterBundleRoute) {
      dispatch(fetchOfferFlightPrice(offerId, airport.code))
    }
  }, [airport, charterBundleRoute, dispatch, offerId])
}

export default useOfferPageAirportEffects
